document.addEventListener('DOMContentLoaded', () => {
  let siblingBottomAdjust = [
    '.clip-path-ellipse-concave-concave',
    '.clip-path-ellipse-concave-convex',
    '.clip-path-ellipse-concave-square',
    '.clip-path-ellipse-convex-concave',
    '.clip-path-ellipse-convex-convex',
    '.clip-path-ellipse-convex-square'
  ];
  let siblingTopAdjust = [
    '.clip-path-ellipse-concave-concave',
    '.clip-path-ellipse-concave-convex',
    '.clip-path-ellipse-convex-concave',
    '.clip-path-ellipse-convex-convex',
    '.clip-path-ellipse-square-concave',
    '.clip-path-ellipse-square-convex'
  ];
  document.querySelectorAll('.wf-block').forEach((elem, ind) => {
    if (elem.previousElementSibling && elem.querySelector(siblingBottomAdjust.join(','))) {
      elem.previousElementSibling.classList.add('wf-block-clip-adjust-bottom');
    }
    if (elem.nextElementSibling && elem.querySelector(siblingTopAdjust.join(','))) {
      elem.nextElementSibling.classList.add('wf-block-clip-adjust-top');
    }
  })
  document.querySelectorAll(siblingTopAdjust.map((a) => '.page-banner' + a).join(',')).forEach((elem) => {
    elem.nextElementSibling.classList.add('wf-block-clip-adjust-top');
  })
});